module.exports = __webpack_public_path__ + "static/post3-e20336881da9d33ad1e0388126bab7fd.png";